// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"489":"61bf55ac318b34e9e9e7","793":"ea821ee43878085ef69c","845":"4608422c654c0d80ba02"}[chunkId] + ".bundle.js";
};